import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { UserService, userServiceToken } from 'go-modules/models/user/user.service';
import { FolderListDataSource } from '@go-modules/services/folder-list-datasource/folder-list-datasource';
import { CourseFolder } from '@go-modules/services/course/interfaces/course-folder.interface';
import { MatTable } from '@angular/material/table';
import { map, Observable } from 'rxjs';
import { MenuComponent } from '@go-modules/components/menus/menu/menu.component';
import { NgxFeatureFlagService } from '@go-modules/services/feature-flag/feature-flag.service';
import { BadgeColors } from '@go-modules/components/badge/badge.constants';
import { TranslateService } from '@ngx-translate/core';
import dayjs from 'dayjs';
import { FIRST_COMMENT_TOUR_CLASSES } from '@go-modules/services/go-pulse-tour/constants/first-comment-tour';

@Component({
	selector: 'folders-table-view',
	templateUrl: './folders-table-view.component.html',
	styleUrls: ['./folders-table-view.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class NgxFolderTableViewComponent implements OnInit {
	@ViewChild(MatTable) public table: MatTable<any>;
	@ViewChild('tableElementRef', {read: ElementRef}) public tableElementRef: ElementRef<HTMLTableElement>;
	@ViewChild(MenuComponent) public menuComponent: MenuComponent;
	@Output() public goToFolder: EventEmitter<any>  = new EventEmitter();

	public FirstCommentTourClasses = FIRST_COMMENT_TOUR_CLASSES;
	public displayColumns: string[];
	public selectedFolder: any;
	public BadgeColors = BadgeColors;
	public hasNoEndDate$: Observable<boolean>;

	constructor (
		public folderListDataSource: FolderListDataSource,
		@Inject(userServiceToken) public userService: UserService,
		private featureFlag: NgxFeatureFlagService,
		private translate: TranslateService
	) {
		this.displayColumns = ['attention_needed', 'name', 'end_date', 'updated_at', 'actions'];
	}

	public ngOnInit (): void {
		this.hasNoEndDate$ = this.folderListDataSource.connect()
			.pipe(
				map((folders) => folders.every((folder) => !folder.end_date))
			);
	}

	public openMenu (event: MouseEvent, folder) {
		event.stopPropagation();
		// open browser menu on shift right click
		if (event.button === 2 && event.shiftKey) {
			return;
		}

		if (!folder.hasInstructorRole(true) && !this.userService.currentUser.is_root_user) {
			return;
		}

		event.preventDefault();
		this.selectedFolder = folder;
		this.menuComponent.openMenu(event, this.tableElementRef.nativeElement);
	}

	public unviewedState (folder: CourseFolder): boolean {
		return folder.hasReviewerRole(true) && folder.stats?.attention_needed;
	}

	public shouldShowFreeTrialBadge (folder): boolean {
		if (this.featureFlag.isAvailable('AI_TRIAL')) {
			return folder.hasInstructorRole(true) && folder.stats?.license_trial_exists;
		}
		return false;
	}

	public getAriaLabel (folder) {
		let translation = folder.name;
		translation += ' , ' + this.translate.instant('course-table-last_modified') + ' ' + dayjs(folder.updated_at).format('MMM D, YYYY');

		if (this.shouldShowFreeTrialBadge(folder)) {
			translation += ' , ' + this.translate.instant('folder-free-trial-badge-label');
		}
		return translation;
	}
}
